
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tags",
      function () {
        return require("private-next-pages/tags/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tags"])
      });
    }
  